import { HomeMessage, MessageLabels } from '../types'

interface UseExpandedMessageParams {
  message: HomeMessage | null
  labels: MessageLabels
  onToggle: (message: HomeMessage) => void
}

const useExpandedMessage = ({ message, labels, onToggle }: UseExpandedMessageParams) => {
  const onClose = () => {
    if (message === null) return
    onToggle(message)
    document.getElementById(`home-message-${message.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return {
    title: message === null ? '' : message.title || labels.untitled,
    closeLabel: labels.close,
    onClose,
  }
}

export default useExpandedMessage
